import { userSignedIn, userSignedOut } from '../ducks/app';
import oidcService from '../oidc/service';
import { useUserStore } from '../stores/user';

export default async ({ store }) => {
  if (!oidcService.isValid()) {
    useUserStore.getState().setSilentAttempted(true);
    return;
  }

  oidcService
    .loginSilent()
    .then((silentUser) => {
      useUserStore.getState().setSilentAttempted(true);
      if (silentUser) {
        useUserStore.getState().setUser(silentUser);
        store.dispatch(userSignedIn());
      }
    })
    .catch(() => {
      useUserStore.getState().setSilentAttempted(true);
      oidcService.removeUser();
      useUserStore.getState().setUser(null);
      store.dispatch(userSignedOut());
    });
};
